





























































import { Component, Vue } from 'vue-property-decorator'
import {
  downloadState,
  dismissDownloadError,
  DownloadTask
} from '@/helpers/FileDownload'

@Component
export default class DownloadProgress extends Vue {
  get tasks() {
    return downloadState.tasks
  }

  get errors() {
    return downloadState.errors
  }

  progressText(task: DownloadTask) {
    if (task.total > 0) {
      return `${Math.min(100, Math.floor((task.loaded / task.total) * 100))}%`
    }
    if (task.loaded > 0) {
      return `${(task.loaded / (1024 * 1024)).toFixed(1)}MB`
    }
    return ''
  }

  dismiss(id: number) {
    dismissDownloadError(id)
  }
}
